import { gql } from '@apollo/client';

export const mutation = gql`
  mutation BuildStandaloneSync($settingsJson: jsonb!) {
    build_standalone_sync_file(settingsJson: $settingsJson) {
      status
      size
      data
      versionInfo {
        buildType
        syncInjectorVersion
        syncVersions {
          syncName
          buildVersion
        }
      }
    }
  }
`;

export function buildVariables({ settingsJson }) {
  return {
    settingsJson,
  };
}
